<app-header></app-header>

<main id="page" class="route-container">
    <router-outlet #routerOutlet="outlet"></router-outlet>
</main>

<footer class="footer">
    <span>© Stephen Fluin</span>
    <!-- The admin hint comes from localStorage, so this never loads the admin module for visitors -->
    @if (adminService.isAdmin()) {
    <a routerLink="/admin">Admin</a>
    }
</footer>